var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDietOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1a1 1 0 10-2 0v5a1 1 0 102 0V1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11a1 1 0 00-1 1 11.993 11.993 0 007.002 10.9c.132.064.28.1.435.1h9.126a1 1 0 00.414-.09A11.994 11.994 0 0024 12a1 1 0 00-1-1H1zm19.41 6.404A9.994 9.994 0 0116.34 21H7.66a9.994 9.994 0 01-5.61-8h19.9a9.993 9.993 0 01-1.54 4.404z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2a1 1 0 011 1v5a1 1 0 01-2 0V3a1 1 0 011-1zM19 3a1 1 0 10-2 0v5a1 1 0 102 0V3z"
  })));
}
export default SvgDietOutline;